

















































import { library } from '@fortawesome/fontawesome-svg-core';
import { faSave, faTrash } from '@fortawesome/pro-light-svg-icons';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { NetworkTemplate, Network, Response } from '@/types';
import UpFormGroup from '../Common/UpFormGroup.vue';
import { networkTemplateSvc } from '@/services';

library.add(faSave, faTrash);

@Component({
  name: 'network-template-form',
  components: {
    UpFormGroup
  }
})
export default class NetworkTemplateForm extends Vue {
  @Prop({ required: true })
  private template!: NetworkTemplate;
  @Prop({ default: false })
  private createForm!: boolean;

  private thisTemplate: NetworkTemplate = this.template;

  private isLoading: boolean = false;
  private status: any[] = [
    { value: 'active', text: 'Active' },
    { value: 'inactive', text: 'Inactive' }
  ];

  async deleteNetworkTemplate() {
    this.isLoading = true;
    const resp: Response = await networkTemplateSvc.deleteNetworkTemplate(this
      .thisTemplate.id as number);
    if (resp) {
      this.$emit('deleted', this.thisTemplate);
    }
    this.isLoading = false;
  }

  async saveNetworkTemplate() {
    this.isLoading = true;
    const template = {
      id: this.thisTemplate.id,
      affiliate_network_id: this.thisTemplate.affiliate_network!.id,
      template: this.thisTemplate.template,
      status: this.thisTemplate.status
    };
    const newTemplate: NetworkTemplate = await networkTemplateSvc.mutateNetworkTemplate(
      template
    );
    if (newTemplate) {
      this.thisTemplate.id = newTemplate.id;

      if (this.createForm) {
        this.$emit('saved', { ...this.thisTemplate });
        this.thisTemplate = {
          ...this.thisTemplate,
          id: undefined,
          status: 'active',
          template: ''
        };
      }
    }
    this.isLoading = false;
  }
}
